import { icons } from './assets/icons';

// This will automatically create a list of all icon names
// from your central icon index file.
export const iconList = Object.keys(icons);